/**
 * 移动端客户细分详情 - 客户列表页
 */
import React, { useEffect, useState } from 'react';
import {
  List,
  PullToRefresh,
  Empty,
  Avatar,
  Skeleton,
} from 'antd-mobile';
import { adminCustomerSegmentApi } from '../../api/index';
import Toast from 'antd-mobile/es/components/toast';
import { useNavigate, useParams } from 'react-router-dom';

export default function MobileCustomerSegmentCustomersPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [customers, setCustomers] = useState([]);
  const [segment, setSegment] = useState(null);

  useEffect(() => {
    fetchCustomers();
  }, [id]);

  const fetchCustomers = async () => {
    try {
      const segmentData = await adminCustomerSegmentApi.getById(id);
      setSegment(segmentData);

      const customersData = await adminCustomerSegmentApi.getCustomers(id);
      setCustomers(customersData || []);
    } catch (err) {
      Toast.show('获取客户列表失败');
    } finally {
      setLoading(false);
    }
  };

  const refreshData = async () => {
    await fetchCustomers();
  };

  if (loading) {
    return (
      <div style={{ padding: 16 }}>
        <Skeleton.Title rows={3} />
        <Skeleton.Title rows={5} style={{ marginTop: 16 }} />
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', padding: 16 }}>
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, margin: 0 }}>
          {segment?.name || '客户列表'}
        </h2>
        <div style={{ fontSize: 13, color: '#999', marginTop: 4 }}>
          客户数：{customers.length}
        </div>
      </div>

      <PullToRefresh onRefresh={refreshData}>
        {customers.length > 0 ? (
          <List>
            {customers.map((customer) => (
              <List.Item
                key={customer.id}
                style={{
                  background: '#fff',
                  marginBottom: 12,
                  padding: '12px 16px',
                }}
                description={
                  <div style={{ fontSize: 13, color: '#999', marginTop: 4 }}>
                    {customer.email}
                  </div>
                }
                prefix={
                  <Avatar
                    style={{ '--background': '#1677ff' }}
                    src={customer.avatarUrl}
                  >
                    {(customer.firstName?.[0] || customer.lastName?.[0] || 'U').toUpperCase()}
                  </Avatar>
                }
              >
                <div style={{ fontSize: 15, fontWeight: 500 }}>
                  {customer.firstName || customer.lastName
                    ? `${customer.lastName || ''} ${customer.firstName || ''}`.trim()
                    : '匿名用户'}
                </div>
              </List.Item>
            ))}
          </List>
        ) : (
          <div style={{ padding: '80px 0' }}>
            <Empty description="暂无客户" />
          </div>
        )}
      </PullToRefresh>
    </div>
  );
}
